var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableFooter',{attrs:{"totalRows":_vm.totalRows,"visibleRows":_vm.visibleRows,"selectedRows":_vm.selectedRows}},[_c('TableFooterRuleCheckStatusContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }